import { baseColors } from "@Constants/baseStyles"
import * as React from "react"
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg"

function SvgYoga(props) {
    return (
        <Svg width={21} height={20} viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <G clipPath="url(#clip0_196_12862)" fill={baseColors.green.primary}>
                <Path d="M10.002 5a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM14.86 18.191l-3.078 1.155 1.531.574a1.25 1.25 0 001.61-.732c.127-.34.09-.696-.062-.997zM4.191 13.829a1.25 1.25 0 00-.878 2.341l1.35.505 3.56-1.335L4.19 13.83zM17.422 14.561a1.254 1.254 0 00-1.61-.731l-10 3.75a1.25 1.25 0 00.878 2.34l10-3.75a1.25 1.25 0 00.732-1.609z" />
                <Path d="M18.752 10h-2.978L13.62 5.69A1.25 1.25 0 0012.47 5H7.532a1.25 1.25 0 00-1.148.69L4.229 10H1.252a1.25 1.25 0 000 2.5h3.75a1.25 1.25 0 001.118-.692l1.382-2.763v4.69l2.5.938 2.5-.938v-4.69l1.381 2.763c.212.424.645.691 1.119.691h3.75a1.25 1.25 0 000-2.5z" />
            </G>
            <Defs>
                <ClipPath id="clip0_196_12862">
                    <Path fill="#fff" transform="translate(.002)" d="M0 0H20V20H0z" />
                </ClipPath>
            </Defs>
        </Svg>
    )
}

export default SvgYoga
